import { Button, DialogActions, DialogContent, Fade, Slide } from "@mui/material";
import { useCustomNavigation } from "hooks/useCustomNavigation";
import queryString from "query-string";
import React, { CSSProperties, useCallback, useMemo } from "react";
import { useLocation } from "react-router";
import { omitBy } from "lodash";
import { TransitionProps } from "@mui/material/transitions";
import { useDeviceDetach } from "hooks/useDeviceDetach";
import { Popup } from "components/Admin/Popup/Popup";
import {Form, useTranslate} from "react-admin";
import { SubmitButton } from "components/Admin/Form/components/SubmitButton/SubmitButton";


type FilterProps = {
  children?: React.ReactNode;
};

const SlideLeft = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const Filter: React.FC<FilterProps> = (props) => {
  const { navigate, state } = useCustomNavigation({ delay: 300 });

  const t = useTranslate();

  const location = useLocation();

  const parsed = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  );

  const submit = useCallback(
    (form: any) => {
      navigate({
        pathname: "..",
        search: `?${queryString.stringify(
          omitBy(form, (value: any) => value === "" || value == null)
        )}`,
      });
    },
    [navigate]
  );

  const clear = useCallback(() => {
    navigate({
      pathname: "..",
      search: "",
    });
  }, [navigate]);

  const { isMobile } = useDeviceDetach();

  const transitionComponent = useMemo(() => {
    if (isMobile) {
      return SlideLeft
    }

    return Fade
  }, [isMobile])

  return (
    <Popup
      show={state === "show"}
      onClose={() => navigate({ pathname: "..", search: location.search })}
      label={t("actions.filter")}
      zIndex={200}
      TransitionComponent={transitionComponent}
    >
      <Form defaultValues={parsed} onSubmit={submit}>
        <DialogContent>{props.children}</DialogContent>

        <DialogActions>
          <Button color="primary" variant="contained" onClick={clear}>
            {t("ra.action.clear_input_value")}
          </Button>
          <SubmitButton color="primary" variant="contained">
            {t("actions.show")}
          </SubmitButton>
        </DialogActions>
      </Form>
    </Popup>
  );
};

const styles: { [key: string]: CSSProperties } = {
  form: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
};
